import { motion } from "framer-motion";
import { WHY_US_ITEMS } from "@/constants/business";

export default function ReassuranceSection() {
  return (
    <section id="pourquoi-nous" data-testid="reassurance-section" className="py-14 md:py-20 px-4 md:px-8 bg-graylight">
      <div className="max-w-7xl mx-auto">
        <div className="mb-10 max-w-2xl">
          <span className="text-xs uppercase tracking-[0.2em] font-bold text-orange">Pourquoi nous choisir</span>
          <h2 className="font-heading font-bold text-3xl md:text-4xl tracking-tight text-navy mt-3">
            Un transport organisé, du premier contact à la livraison
          </h2>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 md:gap-4">
          {WHY_US_ITEMS.map((item, i) => (
            <motion.div
              key={item.text}
              initial={{ opacity: 0, y: 14 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.3, delay: (i % 4) * 0.05 }}
              data-testid={`reassurance-item-${i}`}
              className="flex flex-col items-start gap-3 bg-white border border-gray-200 rounded-xl p-4 md:p-5"
            >
              <item.icon className="w-5 h-5 text-orange" />
              <p className="text-xs md:text-sm font-semibold text-navy leading-snug">{item.text}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
